import { render, staticRenderFns } from "./ImportDetail.vue?vue&type=template&id=a457a44a&"
import script from "./ImportDetail.vue?vue&type=script&lang=js&"
export * from "./ImportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports